export const publicHiringStatus = {
  acceptingApplications: false,
  closedLabel: 'Hiring is closed',
  closedMessage: 'Our hiring is closed, please come back later.',
};
